import React from 'react';
import {RoutePermittedRole} from '../../shared/constants/AppEnums';

const Transaction = React.lazy(() => import('./transaction'));
const CardPayments = React.lazy(() => import('./card-payments'));

export const financeConfig = [
  {
    permittedRole: RoutePermittedRole.user,
    path: '/finance/transaction',
    element: <Transaction />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/finance/card-payments',
    element: <CardPayments />,
  },
];
